module.exports = __webpack_public_path__ + "img/title4.effec60f.png";